"use client";

import Logo from "@/assets/logos/doctor_m_logo.svg?react";
import { Stepper } from "@/components/ui/stepper/Stepper";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import QuitConfirmationModal from "../modal/OuitConfirmationModal";
import CloseIcon from "@/assets/icons/close.svg?react";
import { CLink } from "@/components/common/customLink/CustomLink";

import RenderCurrencyInText from "@/components/common/RenderCurrencyInText";

interface EyeTestHeaderViewProps {
  translations?: Record<string, string>;
  title?: string;
  indicators: { id: string; label?: string }[];
  progressIndex: number;
  progressWidth: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isSuccessPage?: boolean;
  onCancelBooking?: () => void;
}

const EyeTestHeaderView: FC<EyeTestHeaderViewProps> = ({
  translations,
  title,
  indicators,
  progressIndex,
  progressWidth,
  setIsOpen,
  isSuccessPage,
  onCancelBooking,
}) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false);

  const handleCloseClick = () => {
    if (isSuccessPage && onCancelBooking) {
      onCancelBooking();
    } else {
      setIsConfirmationOpen(true);
    }
  };

  return (
    <div className="border-b-#c4c4c4 fixed top-0 z-20 flex w-full flex-col gap-5 border-b-[0.063rem] bg-white px-[1.875rem] py-8 md:gap-12 md:px-12">
      <div className="grid w-full grid-cols-9">
        <div className="col-span-9 flex items-center justify-between md:col-span-3">
          <CLink href={"/"} className="cursor-pointer">
            <Logo />
          </CLink>
          <CloseIcon
            className="flex cursor-pointer text-sm md:hidden"
            onClick={handleCloseClick}
            height={14}
            width={14}
          />
          <RenderCurrencyInText 
            text={title} 
            className="hidden text-xl font-bold xl:flex" 
          />
        </div>
        <div className="col-span-6 hidden items-center justify-between pl-12 md:flex">
          <div className="flex items-center justify-start gap-12">
            <div className="ml-4 md:w-[20rem] lg:w-[31.125rem]">
              <Stepper
                activeStep={progressIndex}
                steps={indicators.map((i) => i.label ?? "")}
                inactiveBgColor="bg-[#C4C4C4]"
                inactiveTextColor="text-[#C4C4C4]"
              />
            </div>
          </div>
          <CloseIcon
            className="cursor-pointer text-sm"
            onClick={handleCloseClick}
            height={14}
            width={14}
          />
        </div>
        <QuitConfirmationModal
          isOpen={isConfirmationOpen}
          toggle={() => setIsConfirmationOpen(!isConfirmationOpen)}
          translations={translations}
        />
      </div>
      <div className="flex w-full md:hidden">
        <Stepper
          className="w-full"
          activeStep={progressIndex}
          steps={indicators.map((i) => i.label ?? "")}
          inactiveBgColor="bg-[#C4C4C4]"
          inactiveTextColor="text-[#C4C4C4]"
        />
      </div>
    </div>
  );
};

export default EyeTestHeaderView;
